import { render, staticRenderFns } from "./m-file-details.vue?vue&type=template&id=50eb043d&"
import script from "./m-file-details.vue?vue&type=script&lang=js&"
export * from "./m-file-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports